module.exports = __webpack_public_path__ + "img/introduce-5.fa462a45.png";